import React from 'react'
import { css } from 'emotion'
import * as images from 'images'

const RewardsLeftArrowButtonView = ({ disabled }) => (
  <img
    className={styles.leftArrow}
    src={images.rewardArrowLeft}
    style={disabled ? { opacity: 0.5 } : {}}
    alt="Left Arrow"
  />
)

const styles = {
  leftArrow: css({
    objectFit: 'contain',
    width: '8.5rem',
    position: 'absolute',
    top: '46%',
    left: '1.25rem',
    transition: 'all .2s',
    '&:hover': {
      transform: 'translateX(-1px)',
    },
    '&:active': {
      transform: 'translate(1px, .5px)',
    },
  }),
}

export default RewardsLeftArrowButtonView
